import React from 'react';
import MeAgendaContainer from '../../../Components/Dashboards/Me/MeAgendaContainer';

export default function MeNCA() {
    return (
        <div className='page-body'>
            <MeAgendaContainer defaultTab="NCA" />
        </div>
    );
}
